<div class="dialog-header-container d-flex align-items-center justify-content-between p-3 border-bottom bg-white">
  <h2 mat-dialog-title class="m-0 fs-5 fw-bold text-dark">{{ inputData.title }}</h2>
  <button mat-icon-button mat-dialog-close (click)="resetForm()" aria-label="Fermer">
    <mat-icon class="text-muted">close</mat-icon>
  </button>
</div>

<mat-dialog-content [formGroup]="collaborateurForm" class="p-4 bg-white custom-dialog-content">
  <div class="row g-3">
    
    <!-- Colonne Gauche -->
    <div class="col-12 col-md-6 d-flex flex-column gap-1">
      
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Nom</mat-label>
        <input matInput type="text" formControlName="name" placeholder="Entrez le nom du collaborateur">
        @if (collaborateurForm.get('name')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Code</mat-label>
        <input matInput type="text" formControlName="code" placeholder="Entrez le Code">
        @if (collaborateurForm.get('code')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Propriétaire</mat-label>
        <input matInput type="text" formControlName="owner" placeholder="Entrez le nom du proprietaire">
        @if (collaborateurForm.get('owner')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Adresse</mat-label>
        <input matInput type="text" formControlName="adresse" placeholder="Entrez le nom du proprietaire">
        @if (collaborateurForm.get('adresse')?.hasError('required')) {<mat-error>obligatoire</mat-error>}
      </mat-form-field>

      <div class="file-upload-wrapper my-2">
        <input type="file" #fileInput style="display: none" (change)="onFileSelected($event)">
        <button type="button" mat-stroked-button color="primary" [matTooltip]="(collaborateurForm.get('logo')?.invalid) ? 'obligatoire' : ''" (click)="fileInput.click()" class="w-100 btn-upload-logo">
          <mat-icon class="me-1">cloud_upload</mat-icon>
          <span>Choisir un logo</span>
        </button>
      </div>

      <mat-form-field appearance="outline" class="w-100" *ngIf="fileName">
        <mat-label>Selected File</mat-label>
        <input matInput [value]="fileName" disabled>
      </mat-form-field>

      <div class="row g-2">
        <div class="col-12 col-sm-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>NIU</mat-label>
            <input matInput formControlName="niu" placeholder="Entrez un nIU">
          </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>RCCM</mat-label>
            <input matInput formControlName="rccm" placeholder="registre de commerce et du credit mobilier">
          </mat-form-field>
        </div>
      </div>

    </div>

    <!-- Colonne Droite -->
    <div class="col-12 col-md-6 d-flex flex-column gap-1">
      
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Capital</mat-label>
        <input matInput formControlName="capital" placeholder="Entrez le montant du capital">
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Agrément</mat-label>
        <input matInput formControlName="agrement" placeholder="Entrez un n* d'agrement">
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>B.P</mat-label>
        <input matInput formControlName="bp" placeholder="Entrez une B.P">
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Tel</mat-label>
        <input matInput formControlName="tel" placeholder="Entrez un n* de telephone">
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="Entrez une email">
        @if (collaborateurForm.get('email')?.hasError('email')) {<mat-error>email invalide</mat-error>}
      </mat-form-field>

    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-3 border-top bg-light m-0 gap-2">
  <button mat-stroked-button mat-dialog-close color="warn" class="px-4" (click)="resetForm()">Fermer</button>
  
  @if (inputData.update) {
    <button [disabled]="collaborateurForm.invalid" mat-flat-button color="primary" class="px-4" (click)="onUpdate()">Modifier</button>
  } @else {
    <button [disabled]="collaborateurForm.invalid" mat-flat-button color="primary" class="px-4" (click)="onAdd()">Enregistrer</button>
  }
</mat-dialog-actions>
